<template>
  <v-app>
    <Header ref="header" v-if="this.$store.state.loginStatus" @rerender="rerender()" />
    <v-main>
      <v-container align-start fluid :style="style">
        <v-navigation-drawer app :clipped="$vuetify.breakpoint.lgAndUp" v-if="loginStatus">
          <SideNav @rerender="rerender()" />
        </v-navigation-drawer>
        <v-container align-start fluid :style="this.$store.state.style">
          <Loading v-if="loading" />
          <router-view v-else :clientHeight="clientHeight" :key="componentKey" @research="research">
            <v-row class="mx-auto" v-if="alerts.length >= 1">
              <div :key="index" v-for="(alert, index) in alerts">
                <v-alert dismissible :type="alert.type">{{ alert.message }}</v-alert>
              </div>
            </v-row>
          </router-view>
        </v-container>
      </v-container>
    </v-main>
    <Footer ref="footer" />
  </v-app>
</template>

<script>
import Footer from "./components/Footer.vue";
import Header from "./components/Header.vue";
import Loading from "@/components/Loading";
import SideNav from "./components/SideNav.vue";

import firebase from "firebase";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "App",

  components: {
    Footer,
    Header,
    Loading,
    SideNav
  },

  computed: {
    ...mapGetters(["loading", "loginStatus", "style"])
  },

  created() {
    // リロード時・ログイン・ログアウト時の処理を記載
    firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        // ユーザー認証中の処理
        this.fetchLoginStatus(true); // ログイン状況を「ログイン中」に更新
        this.fetchMyGroups(user);
        this.setLoginUser(user); // ログイン中のユーザー情報を更新
        this.setStyle(""); // styleを更新
        if (this.$router.currentRoute.name === "Login") {
          this.$router.push("/top"); // ログイン画面にいた場合は/topへ遷移
        }
        this["friend/fetchLoginUserFriends"](user.uid);
        this["group/fetchGroups"]();
        this["job/fetchMyJobs"](user);
        this["record/fetchMyRecords"](user);
        this["record/fetchTimeLine"](user);
        await this["user/fetchUsers"]();
        this.setLoading(false);
      } else {
        // ユーザー未認証中の処理
        this.deleteLoginUser(); // ログイン中のユーザー情報を削除
        this.fetchLoginStatus(false); //ログアウト中に更新
        this.setStyle("padding: 0px"); // styleを更新
        if (this.$router.currentRoute.name !== "Login") {
          this.$router.push("/"); // ログイン画面以外にいた場合はLogin画面へ遷移
        }
        this.setLoading(false);
      }
    });
  },

  data: () => ({
    alerts: [],
    clientHeight: 0,
    componentKey: 0
  }),

  methods: {
    ...mapActions(["deleteLoginUser", "fetchLoginStatus", "fetchMyGroups", "setLoading", "setLoginUser", "setStyle", "friend/fetchLoginUserFriends", "group/fetchGroups", "job/fetchMyJobs", "record/fetchMyRecords", "record/fetchTimeLine", "user/fetchUsers"]),
    research() {
      this.$refs.header.globalSearch();
    },
    // 再レンダリングを行います.
    rerender() {
      this.componentKey++;
      this.setLoading(false);
    }
  },

  mounted() {
    this.clientHeight = this.$refs.footer.$el.clientHeight;
  }
};
</script>
